import { render, staticRenderFns } from "./orBreak.vue?vue&type=template&id=46adc48d&scoped=true&"
import script from "./orBreak.vue?vue&type=script&lang=js&"
export * from "./orBreak.vue?vue&type=script&lang=js&"
import style0 from "./orBreak.vue?vue&type=style&index=0&id=46adc48d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46adc48d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
